"use strict";
const CAMPAIGN_COLLECTION_ID = 'campaign_collection';
const TASK_COLLECTION_ID = 'task_collection';
const TOUCHPOINT_COLLECTION_ID = 'touchpoint_collection';
module.exports = {
    CAMPAIGN_COLLECTION_ID,
    TASK_COLLECTION_ID,
    TOUCHPOINT_COLLECTION_ID,
};
//# sourceMappingURL=consts.js.map